module.exports = __webpack_public_path__ + "static/media/IMG_0884.38e84db9.jpg";